/** Keys for visit records in medical chronology diffs (single source of truth). */
export const VISIT_FIELD_KEYS = [
  "visit_date",
  "visit_type_id",
  "provider_name",
  "facility_name",
  "visit_subtype",
] as const;

/** Error label used across the header edit form when the visit type field is blocking a save. */
export const VISIT_TYPE_ERROR_KEY = "Visit type";

export const NEW_VISIT_CITATIONS_ERROR_KEY = "Citations";
